export default __webpack_public_path__ + "static/media/hero-caro-mbl-new-october.4a01f3a2.png";